import BaseModel from './BaseModel';
import Programmation from './Programmation';
import * as _ from 'es-toolkit';
import { v4 } from 'uuid';
import {
    slot_overrides_defaults,
    strip_inherited_slot_fields,
} from '../services/programmationGroupDefaults';

/** Fields accepted by Kore ProgrammationGroup::db_infos (+ nested slots). */
const GROUP_PERSISTED_KEYS = [
    'title',
    'description',
    'events',
    'start_at',
    'stop_at',
    'period_nb',
    'period_type',
    'pricinglist_id',
    'bucketlist_id',
    'options',
    'tasks',
    'tkt_instance_id',
    'programmations',
];

/** List-view / client-only keys that must never hit Kore update_properties. */
const GROUP_CLIENT_ONLY_KEYS = [
    'days',
    'times',
    'places',
    'place_id',
    '_titleSort',
    'nb_screenings',
    'validation_errors',
];

function strip_group_client_only_fields(prepared) {
    GROUP_CLIENT_ONLY_KEYS.forEach((key) => {
        delete prepared[key];
    });
    return prepared;
}

function pick_group_persisted_fields(source) {
    const picked = {};
    GROUP_PERSISTED_KEYS.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(source, key) && source[key] !== undefined) {
            picked[key] = source[key];
        }
    });
    return picked;
}

/** Class representing a programmation group. */
class ProgrammationGroup extends BaseModel {
    constructor(properties) {
        super(properties);

        this.programmations = (this.programmations || []).map(p => new Programmation(p));
    }

    /**
     * Prepare this object for update.
     * This is used to "normalize", if needed, some properties
     * before to send them.
     *
     * return{BaseModel}
     */
    prepareForUpdate() {
        const prepared = strip_group_client_only_fields(super.prepareForUpdate());

        if (Array.isArray(prepared.events)) {
            prepared.events = prepared.events.filter((ev) => ev && ev.id);
        }
        if (Array.isArray(prepared.tasks)) {
            prepared.tasks = prepared.tasks.filter((task) => task?.activity?.id || task?.activity_id);
        }

        if (prepared.programmations?.length > 0) {
            prepared.programmations = prepared.programmations.map((programmation) => {
                const prepared_slot = new Programmation(programmation).prepareForUpdate();
                if (slot_overrides_defaults(prepared_slot))
                    return prepared_slot;
                return strip_inherited_slot_fields(prepared_slot);
            });
        }

        return prepared;
    }

    /**
     * Prepare this object for duplicate.
     *
     * @return {object}
     */
    prepareForDuplicate() {
        const source = _.cloneDeep(this);
        const prepared = pick_group_persisted_fields(source);

        if (Array.isArray(prepared.programmations)) {
            prepared.programmations = prepared.programmations.map((slot) => {
                const next = { ...slot };
                next.id = v4();
                delete next._id;
                delete next.created_at;
                delete next.updated_at;
                delete next.nb_screenings;
                delete next.screenings;
                return next;
            });
        }

        return new ProgrammationGroup(prepared).prepareForUpdate();
    }
}

export default ProgrammationGroup;
